import update from 'immutability-helper';
import {
  INIT_SEARCH,
  SET_SEARCH_TEXT,
  SET_TAB_TYPE,
  SEARCH_DISCOVER_LOADING,
  SEARCH_DISCOVER_SUCCESS,
  SEARCH_DISCOVER_FAIL,
  SEARCH_NEXT_DISCOVER_SUCCESS,
  SEARCH_NEXT_DISCOVER_FAIL,
  SET_SEARCH_LIKE,
} from '../actionTypes/search';

export default (
  state = {
    searchText: '',
    isLoading: false,
    allData: [],
    journalsData: [],
    itinerariesData: [],
    productData: [],
    dataNext: false,
    statusCode: 0,
    tabType: '',
  },
  action,
) => {
  switch (action.type) {
    case INIT_SEARCH:
      return {
        searchText: '',
        isLoading: false,
        allData: [],
        journalsData: [],
        itinerariesData: [],
        productData: [],
        dataNext: false,
        statusCode: 0,
        tabType: '',
      };
    case SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      };
    case SET_TAB_TYPE:
      return {
        ...state,
        tabType: action.payload.tabType,
      };
    case SEARCH_DISCOVER_LOADING:
      return {
        ...state,
        isSearch: true,
        searchText: action.payload.searchText,
        isLoading: true,
        allData: [],
        journalsData: [],
        itinerariesData: [],
        productData: [],
      };
    case SEARCH_DISCOVER_SUCCESS:
      return setData(state, action.payload);
    case SEARCH_DISCOVER_FAIL:
      return {
        ...state,
        allData: [],
        journalsData: [],
        itinerariesData: [],
        productData: [],
        dataNext: false,
        statusCode: action.payload.statusCode,
        isLoading: false,
      };
    case SEARCH_NEXT_DISCOVER_SUCCESS:
      return setNextData(state, action.payload);
    case SEARCH_NEXT_DISCOVER_FAIL:
      return {
        ...state,
        allData: [],
        itinerariesData: [],
        journalsData: [],
        productData: [],
        dataNext: false,
        statusCode: action.payload.statusCode,
      };
    case SET_SEARCH_LIKE:
      return setSearchLikeState(state, action.payload);
    default:
      return state;
  }
};

const setSearchLikeState = (state, payload) => {
  const { key, isLike, index } = payload;
  const newState = update(state, {
    [key]: {
      [index]: {
        is_like: { $set: isLike },
      },
    },
  });
  return newState;
};
const setData = (state, payload) => {
  const { key } = payload;
  const newData = {
    ...state,
    dataNext: payload.dataNext,
    statusCode: payload.statusCode,
    isLoading: false,
    [key]: payload.data,
  };
  return newData;
};

const setNextData = (state, payload) => {
  const { key } = payload;
  const newSearchList = {
    ...state,
    dataNext: payload.dataNext,
    statusCode: payload.statusCode,
    isLoading: false,
  };
  newSearchList[key] = [...newSearchList[key], ...payload.data];
  return newSearchList;
};
